<template>
  <b-button
    size="md"
    variant="link"
    :style="{ backgroundColor: '#08A762', color: '#ffffff' }"
    class="ml-3"
    @click="processAssignment"
  >
    <i class="fa fa-arrow-right" />
    Finish Buffering
  </b-button>
</template>

<script lang="ts">
import { notify } from '@kyvg/vue3-notification'
import { BButton } from 'bootstrap-vue-next'
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { none } from '@/services/Helpers'
import { openModal } from '@/services/Modal'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { CUSTOMER_ASSIGNMENTS_DETAILS, STAFF_ASSIGNMENTS_DETAILS } from '@/types/router'

export default defineComponent({
  name: 'Process',
  components: { BButton },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    const processAssignment = () => {
      openModal('confirmWrap', {
        title: 'Process the assignment',
        message: 'Are you sure you want to process the assignment? This action will start the optimization process.',
        okButtonText: 'Process',
        onConfirm: () => {
          assignmentSummaryStore
            .submitProcess()
            .then(() => {
              const isStaff = accountStore.isStaff
              router
                .push({
                  name: isStaff ? STAFF_ASSIGNMENTS_DETAILS : CUSTOMER_ASSIGNMENTS_DETAILS,
                  params: {
                    id: assignmentSummaryStore.reference,
                  },
                })
                .then(none)
            })
            .catch((e) => {
              notify({
                group: 'error',
                text: 'The assignment could not be processed. ' + e.message,
              })
            })
        },
      })
    }

    return {
      processAssignment,
    }
  },
})
</script>
